/**
 * Formats a string using js object for replacing
 *
 * @param str string to format
 * @param obj object to be used as params
 * @example
 * formatObject('Hello {developer}', { developer: 'MS2 Developer' })
 */
export function formatObject(str: string, obj: {}, isCaseSensitive: boolean = true): string {
    if (!str) {
        return '';
    }
    const keys = Object.keys(obj);
    for (const key of keys) {
        str = str.replace(new RegExp(`\\{${key}\\}`, isCaseSensitive ? 'gm' : 'gi'), obj[key as keyof typeof obj]);
    }

    return str;
}
